import { AsyncLocalStorage } from 'async_hooks';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const alsContext = global.__alsContext;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default alsContext as AsyncLocalStorage<any>;
